import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'response-requests'
const actionDecline = '/decline'
const actionAccept = '/accept'
const actionDriverList = '/drivers-list'
const actionAddDriver = '/add-driver'
const actionAddAutomobile = '/add-automobile'
const actionCarsList = '/autos-list'
const actionChangeDriverOwner = '/change-driver-owner'
const actionAutomobleDriverOwner = '/change-automobile-owner'

export default {
  fetchDriverList(data = {}) {
    return Repository.get(action + actionDriverList + getParamsUrl(data))
  },
  fetchAutomobileList(data = {}) {
    return Repository.get(action + actionCarsList + getParamsUrl(data))
  },
  changeDriverOwner(data) {
    return Repository.post(action + actionChangeDriverOwner, data)
  },
  changeAutomobleOwner(data) {
    return Repository.post(action + actionAutomobleDriverOwner, data)
  },
  addDriver(data) {
    return Repository.post(action + actionAddDriver, data)
  },
  addAutomobile(data) {
    return Repository.post(action + actionAddAutomobile, data)
  },
  declineRequest(data) {
    return Repository.post(action + actionDecline, data)
  },
  acceptRequest(data) {
    return Repository.post(action + actionAccept, data)
  },
}
